function widgetLoader() {
  function component() {
    const module = window.AtWidgetBooking
    return module && module.Component
  }
  return new Promise(resolve => {
    if (component()) {
      return resolve(component())
    }
    let script = document.createElement('script')
    script.onload = () => resolve(component())
    script.setAttribute(
      'src',
      `${process.env.VUE_APP_WIDGET_LEGACY_LOCATION}/dist/at-widget-booking.umd.min.js`,
    )
    document.head.appendChild(script)

    const link = document.createElement('link')
    link.setAttribute(
      'href',
      `${process.env.VUE_APP_WIDGET_LEGACY_LOCATION}/dist/at-widget-booking.css`,
    )
    link.setAttribute('type', 'text/css')
    link.setAttribute('rel', 'stylesheet')
    document.head.appendChild(link)
  })
}

// array of function to be executed on widget ready event
let widgetCallQueue = []

export default {
  components: {
    AtWidgetBooking: widgetLoader,
  },

  computed: {
    endpoint() {
      const { VUE_APP_API_LOCATION } = process.env
      if (VUE_APP_API_LOCATION.endsWith('/'))
        return VUE_APP_API_LOCATION.substr(0, VUE_APP_API_LOCATION.length - 1)

      return VUE_APP_API_LOCATION
    },

    stripeKey() {
      return process.env.VUE_APP_STRIPE_KEY
    },
  },

  methods: {
    widgetReady() {
      // on widget ready reset widget store to initial state
      this.widgetStore = this.$refs.widget.$store
      // todo: inspect why we need reset widget state
      this.widgetStore.dispatch('resetInitialStore')
      this.widgetStore.commit('setLocaleLoaded', true)
      widgetCallQueue.forEach(fn => fn())
      widgetCallQueue = []
    },

    whenWidget(fn) {
      if (this.widgetStore) {
        fn()
      }

      widgetCallQueue.push(fn)
    },
  },
}
